import { render } from "./advertisingCenterSpecificContent.vue?vue&type=template&id=4d27dfce&scoped=true"
import script from "./advertisingCenterSpecificContent.vue?vue&type=script&lang=js"
export * from "./advertisingCenterSpecificContent.vue?vue&type=script&lang=js"

import "./advertisingCenterSpecificContent.vue?vue&type=style&index=0&id=4d27dfce&lang=scss&scoped=true"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.4.32_vue@3.4.32_webpack@5.93.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d27dfce"]])

export default __exports__